export default "__VITE_ASSET__DimJ80t5__"